// Centralized chapter metadata. Keep display date as `date` and add `publishedAt` for sorting.
// Image paths are relative to public folder (e.g., /chapterdata/...).
// The `isPublic` flag determines if a chapter is visible on the chapter list.
// This flag is updated by the update_chapter_visibility.py script at midnight EST.

const chapters = [
  {
    id: "1",
    label: "1",
    folder: "Chapter 1",
    title: "Chapter 1: Welcome to Spirit Falls!",
    date: "Apr 08 2024",
    publishedAt: "2024-04-08",
    isPublic: true,
    description: "Luna makes her way to Spirit Falls and misses an important news broadcast.",
    image: "chapterdata/Chapter 1/Ch1 Page 0.png",
    totalPages: 29,
    pageFiles: [
      {
        filename: "Ch1 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch1 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch1 Page 2&3.png",
        pages: [2, 3]
      },
      {
        filename: "Ch1 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch1 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch1 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch1 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch1 Page 8&9.png",
        pages: [8, 9]
      },
      {
        filename: "Ch1 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch1 Page 11&12.png",
        pages: [11, 12]
      },
      {
        filename: "Ch1 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch1 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch1 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch1 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch1 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch1 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch1 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch1 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch1 Page 21.png",
        pages: [21]
      },
      {
        filename: "Ch1 Page 22.png",
        pages: [22]
      },
      {
        filename: "Ch1 Page 23.png",
        pages: [23]
      },
      {
        filename: "Ch1 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch1 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch1 Page 26.png",
        pages: [26]
      },
      {
        filename: "Ch1 Page 27.png",
        pages: [27]
      },
      {
        filename: "Ch1 Page 28.png",
        pages: [28]
      }
    ]
  },
  {
    id: "2",
    label: "2",
    folder: "Chapter 2",
    title: "Chapter 2: ...Now What?",
    date: "Oct 21 2024",
    publishedAt: "2024-10-21",
    isPublic: true,
    description: "Luna and Brooke try to forget their problems and find one good meal in America's worst town.",
    image: "chapterdata/Chapter 2/Ch2 Page 0.png",
    totalPages: 33,
    pageFiles: [
      {
        filename: "Ch2 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch2 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch2 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch2 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch2 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch2 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch2 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch2 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch2 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch2 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch2 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch2 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch2 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch2 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch2 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch2 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch2 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch2 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch2 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch2 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch2 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch2 Page 21&22.png",
        pages: [21, 22]
      },
      {
        filename: "Ch2 Page 23.png",
        pages: [23]
      },
      {
        filename: "Ch2 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch2 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch2 Page 26.png",
        pages: [26]
      },
      {
        filename: "Ch2 Page 27.png",
        pages: [27]
      },
      {
        filename: "Ch2 Page 28.png",
        pages: [28]
      },
      {
        filename: "Ch2 Page 29&30.png",
        pages: [29, 30]
      },
      {
        filename: "Ch2 Page 31.png",
        pages: [31]
      },
      {
        filename: "Ch2 Page 32.png",
        pages: [32]
      }
    ]
  },
  {
    id: "3",
    label: "3",
    folder: "Chapter 3",
    title: "Chapter 3: Beloved By All.",
    date: "Jan 21 2025",
    publishedAt: "2025-01-21",
    isPublic: true,
    description: "The people of Spirit Falls interrogate what Wanda means to them.",
    image: "chapterdata/Chapter 3/Ch3 Page 0.png",
    totalPages: 26,
    pageFiles: [
      {
        filename: "Ch3 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch3 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch3 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch3 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch3 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch3 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch3 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch3 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch3 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch3 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch3 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch3 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch3 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch3 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch3 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch3 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch3 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch3 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch3 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch3 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch3 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch3 Page 21.png",
        pages: [21]
      },
      {
        filename: "Ch3 Page 22&23.png",
        pages: [22, 23]
      },
      {
        filename: "Ch3 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch3 Page 25.png",
        pages: [25]
      }
    ]
  },
  {
    id: "4",
    label: "4",
    folder: "Chapter 4",
    title: "Chapter 4: Do Not Enter",
    date: "May 13 2025",
    publishedAt: "2025-05-13",
    isPublic: true,
    description: "Luna and Brooke clean up Wanda's mess.",
    image: "chapterdata/Chapter 4/Ch4 Page 0.png",
    totalPages: 15,
    pageFiles: [
      {
        filename: "Ch4 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch4 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch4 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch4 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch4 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch4 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch4 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch4 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch4 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch4 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch4 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch4 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch4 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch4 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch4 Page 14.png",
        pages: [14]
      }
    ]
  },
  {
    id: "5",
    label: "5",
    folder: "Chapter 5",
    title: "Chapter 5: Grey Area",
    date: "Jun 10 2025",
    publishedAt: "2025-06-10",
    isPublic: true,
    description: "It's kind of a grey area.",
    image: "chapterdata/Chapter 5/Ch5 Page 0.png",
    totalPages: 15,
    pageFiles: [
      {
        filename: "Ch5 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch5 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch5 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch5 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch5 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch5 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch5 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch5 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch5 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch5 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch5 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch5 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch5 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch5 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch5 Page 14.png",
        pages: [14]
      }
    ]
  },
  {
    id: "6",
    label: "6",
    folder: "Chapter 6",
    title: "Chapter 6: Long Shot (Part 1)",
    date: "Jul 10 2025",
    publishedAt: "2025-07-10",
    isPublic: true,
    description: "Luna changes her mind.",
    image: "chapterdata/Chapter 6/Ch6 Page 0.png",
    totalPages: 15,
    pageFiles: [
      {
        filename: "Ch6 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch6 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch6 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch6 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch6 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch6 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch6 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch6 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch6 Page 8&9.png",
        pages: [8, 9]
      },
      {
        filename: "Ch6 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch6 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch6 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch6 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch6 Page 14.png",
        pages: [14]
      }
    ]
  },
  {
    id: "7",
    label: "7",
    folder: "Chapter 7",
    title: "Chapter 7: Long Shot (Part 2)",
    date: "Aug 08 2025",
    publishedAt: "2025-08-08",
    isPublic: true,
    description: "Things are put into motion.",
    image: "chapterdata/Chapter 7/Ch7 Page 0.png",
    totalPages: 0,
    pageFiles: [
    ]
  },
  {
    id: "8",
    label: "8",
    folder: "Chapter 8",
    title: "Chapter 8: Long Shot (Part 3)",
    date: "Sep 08 2025",
    publishedAt: "2025-09-08",
    isPublic: true,
    description: "The part that everyone has been waiting for.",
    image: "chapterdata/Chapter 8/Ch8 Page 0.png",
    totalPages: 15,
    pageFiles: [
      {
        filename: "Ch8 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch8 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch8 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch8 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch8 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch8 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch8 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch8 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch8 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch8 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch8 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch8 Page 11&12.png",
        pages: [11, 12]
      },
      {
        filename: "Ch8 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch8 Page 14.png",
        pages: [14]
      }
    ]
  },
  {
    id: "9",
    label: "9",
    folder: "Chapter 9",
    title: "Chapter 9: Long Shot (Part 4)",
    date: "Oct 04 2025",
    publishedAt: "2025-10-04",
    isPublic: true,
    description: "Where everything Falls into place.",
    image: "chapterdata/Chapter 9/Ch9 Page 0.png",
    totalPages: 19,
    pageFiles: [
      {
        filename: "Ch9 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch9 Page 1&2.png",
        pages: [1, 2]
      },
      {
        filename: "Ch9 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch9 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch9 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch9 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch9 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch9 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch9 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch9 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch9 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch9 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch9 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch9 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch9 Page 15&16.png",
        pages: [15, 16]
      },
      {
        filename: "Ch9 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch9 Page 18.png",
        pages: [18]
      }
    ]
  },
  {
    id: "10",
    label: "10",
    folder: "Chapter 10",
    title: "Chapter 10: Jumped the Gun",
    date: "Nov 05 2025",
    publishedAt: "2025-11-05",
    isPublic: true,
    description: "Everyone makes mistakes.",
    image: "chapterdata/Chapter 10/Ch10 Page 0.png",
    totalPages: 21,
    pageFiles: [
      {
        filename: "Ch10 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch10 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch10 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch10 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch10 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch10 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch10 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch10 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch10 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch10 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch10 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch10 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch10 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch10 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch10 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch10 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch10 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch10 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch10 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch10 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch10 Page 20.png",
        pages: [20]
      }
    ]
  },
  {
    id: "11",
    label: "11",
    folder: "Chapter 11",
    title: "Chapter 11: Bassline",
    date: "Dec 05 2025",
    publishedAt: "2025-12-05",
    isPublic: true,
    description: "Uhm... can we pretend that DIDN'T just happen?",
    image: "chapterdata/Chapter 11/Ch11 Page 0.png",
    totalPages: 19,
    pageFiles: [
      {
        filename: "Ch11 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch11 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch11 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch11 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch11 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch11 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch11 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch11 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch11 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch11 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch11 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch11 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch11 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch11 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch11 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch11 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch11 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch11 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch11 Page 18.png",
        pages: [18]
      }
    ]
  },
  {
    id: "12",
    label: "12",
    folder: "Chapter 12",
    title: "Chapter 12: Threshold",
    date: "Jan 05 2026",
    publishedAt: "2026-01-05",
    isPublic: true,
    description: "Can't you just let that go?",
    image: "chapterdata/Chapter 12/Ch12 Page 0.png",
    totalPages: 27,
    pageFiles: [
      {
        filename: "Ch12 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch12 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch12 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch12 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch12 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch12 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch12 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch12 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch12 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch12 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch12 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch12 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch12 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch12 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch12 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch12 Page 15&16.png",
        pages: [15, 16]
      },
      {
        filename: "Ch12 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch12 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch12 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch12 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch12 Page 21.png",
        pages: [21]
      },
      {
        filename: "Ch12 Page 22.png",
        pages: [22]
      },
      {
        filename: "Ch12 Page 23.png",
        pages: [23]
      },
      {
        filename: "Ch12 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch12 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch12 Page 26.png",
        pages: [26]
      }
    ]
  },
  {
    id: "13",
    label: "13",
    folder: "Chapter 13",
    title: "Chapter 13: Attack",
    date: "Feb 01 2026",
    publishedAt: "2026-02-01",
    isPublic: true,
    description: "The start of a new sound.",
    image: "chapterdata/Chapter 13/Ch13 Page 0.png",
    totalPages: 35,
    pageFiles: [
      {
        filename: "Ch13 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch13 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch13 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch13 Page 3&4.png",
        pages: [3, 4]
      },
      {
        filename: "Ch13 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch13 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch13 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch13 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch13 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch13 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch13 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch13 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch13 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch13 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch13 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch13 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch13 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch13 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch13 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch13 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch13 Page 21.png",
        pages: [21]
      },
      {
        filename: "Ch13 Page 22.png",
        pages: [22]
      },
      {
        filename: "Ch13 Page 23.png",
        pages: [23]
      },
      {
        filename: "Ch13 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch13 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch13 Page 26.png",
        pages: [26]
      },
      {
        filename: "Ch13 Page 27.png",
        pages: [27]
      },
      {
        filename: "Ch13 Page 28.png",
        pages: [28]
      },
      {
        filename: "Ch13 Page 29&30.png",
        pages: [29, 30]
      },
      {
        filename: "Ch13 Page 31.png",
        pages: [31]
      },
      {
        filename: "Ch13 Page 32.png",
        pages: [32]
      },
      {
        filename: "Ch13 Page 33.png",
        pages: [33]
      },
      {
        filename: "Ch13 Page 34.png",
        pages: [34]
      }
    ]
  },
  {
    id: "14",
    label: "14",
    folder: "Chapter 14",
    title: "Chapter 14: Permanence.",
    date: "May 01 2026",
    publishedAt: "2026-05-01",
    isPublic: true,
    description: "Everything is just too real.",
    image: "chapterdata/Chapter 14/Ch14 Page 0.png",
    totalPages: 37,
    pageFiles: [
      {
        filename: "Ch14 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch14 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch14 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch14 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch14 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch14 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch14 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch14 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch14 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch14 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch14 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch14 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch14 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch14 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch14 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch14 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch14 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch14 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch14 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch14 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch14 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch14 Page 21.png",
        pages: [21]
      },
      {
        filename: "Ch14 Page 22.png",
        pages: [22]
      },
      {
        filename: "Ch14 Page 23.png",
        pages: [23]
      },
      {
        filename: "Ch14 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch14 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch14 Page 26.png",
        pages: [26]
      },
      {
        filename: "Ch14 Page 27&28.png",
        pages: [27, 28]
      },
      {
        filename: "Ch14 Page 29.png",
        pages: [29]
      },
      {
        filename: "Ch14 Page 30.png",
        pages: [30]
      },
      {
        filename: "Ch14 Page 31.png",
        pages: [31]
      },
      {
        filename: "Ch14 Page 32.png",
        pages: [32]
      },
      {
        filename: "Ch14 Page 33.png",
        pages: [33]
      },
      {
        filename: "Ch14 Page 34.png",
        pages: [34]
      },
      {
        filename: "Ch14 Page 35.png",
        pages: [35]
      },
      {
        filename: "Ch14 Page 36.png",
        pages: [36]
      }
    ]
  },
  {
    id: "15",
    label: "15",
    folder: "Chapter 15",
    title: "Chapter 15: To Walk the Common Ground",
    date: "May 31 2026",
    publishedAt: "2026-05-31",
    isPublic: true,
    description: "Making good on Wanda's plans, Brooke takes Luna to church.",
    image: "chapterdata/Chapter 15/Ch15 Page 0.png",
    totalPages: 37,
    pageFiles: [
      {
        filename: "Ch15 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch15 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch15 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch15 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch15 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch15 Page 5&6.png",
        pages: [5, 6]
      },
      {
        filename: "Ch15 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch15 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch15 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch15 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch15 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch15 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch15 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch15 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch15 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch15 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch15 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch15 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch15 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch15 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch15 Page 21.png",
        pages: [21]
      },
      {
        filename: "Ch15 Page 22.png",
        pages: [22]
      },
      {
        filename: "Ch15 Page 23&24.png",
        pages: [23, 24]
      },
      {
        filename: "Ch15 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch15 Page 26.png",
        pages: [26]
      },
      {
        filename: "Ch15 Page 27.png",
        pages: [27]
      },
      {
        filename: "Ch15 Page 28.png",
        pages: [28]
      },
      {
        filename: "Ch15 Page 29.png",
        pages: [29]
      },
      {
        filename: "Ch15 Page 30.png",
        pages: [30]
      },
      {
        filename: "Ch15 Page 31&32.png",
        pages: [31, 32]
      },
      {
        filename: "Ch15 Page 33.png",
        pages: [33]
      },
      {
        filename: "Ch15 Page 34.png",
        pages: [34]
      },
      {
        filename: "Ch15 Page 35.png",
        pages: [35]
      },
      {
        filename: "Ch15 Page 36.png",
        pages: [36]
      }
    ]
  },
  {
    id: "16",
    label: "16",
    folder: "Chapter 16",
    title: "Chapter 16: In Her Footsteps",
    date: "Jun 29 2026",
    publishedAt: "2026-06-29",
    isPublic: true,
    description: "Ill-prepared for a battle of wits, Luna loses her fucking mind.",
    image: "chapterdata/Chapter 16/Ch16 Page 0.png",
    totalPages: 31,
    pageFiles: [
      {
        filename: "Ch16 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch16 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch16 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch16 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch16 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch16 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch16 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch16 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch16 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch16 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch16 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch16 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch16 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch16 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch16 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch16 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch16 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch16 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch16 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch16 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch16 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch16 Page 21.png",
        pages: [21]
      },
      {
        filename: "Ch16 Page 22.png",
        pages: [22]
      },
      {
        filename: "Ch16 Page 23.png",
        pages: [23]
      },
      {
        filename: "Ch16 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch16 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch16 Page 26.png",
        pages: [26]
      },
      {
        filename: "Ch16 Page 27.png",
        pages: [27]
      },
      {
        filename: "Ch16 Page 28.png",
        pages: [28]
      },
      {
        filename: "Ch16 Page 29.png",
        pages: [29]
      },
      {
        filename: "Ch16 Page 30.png",
        pages: [30]
      }
    ]
  },
  {
    id: "17",
    label: "17",
    folder: "Chapter 17",
    title: "Chapter 17: Lie/   To Me   /Forever",
    date: "Jul 07 2026",
    publishedAt: "2026-07-07",
    isPublic: true,
    description: "I'm sorry.",
    image: "chapterdata/Chapter 17/Ch17 Page 0.png",
    totalPages: 27,
    pageFiles: [
      {
        filename: "Ch17 Page 0.png",
        pages: [0]
      },
      {
        filename: "Ch17 Page 1.png",
        pages: [1]
      },
      {
        filename: "Ch17 Page 2.png",
        pages: [2]
      },
      {
        filename: "Ch17 Page 3.png",
        pages: [3]
      },
      {
        filename: "Ch17 Page 4.png",
        pages: [4]
      },
      {
        filename: "Ch17 Page 5.png",
        pages: [5]
      },
      {
        filename: "Ch17 Page 6.png",
        pages: [6]
      },
      {
        filename: "Ch17 Page 7.png",
        pages: [7]
      },
      {
        filename: "Ch17 Page 8.png",
        pages: [8]
      },
      {
        filename: "Ch17 Page 9.png",
        pages: [9]
      },
      {
        filename: "Ch17 Page 10.png",
        pages: [10]
      },
      {
        filename: "Ch17 Page 11.png",
        pages: [11]
      },
      {
        filename: "Ch17 Page 12.png",
        pages: [12]
      },
      {
        filename: "Ch17 Page 13.png",
        pages: [13]
      },
      {
        filename: "Ch17 Page 14.png",
        pages: [14]
      },
      {
        filename: "Ch17 Page 15.png",
        pages: [15]
      },
      {
        filename: "Ch17 Page 16.png",
        pages: [16]
      },
      {
        filename: "Ch17 Page 17.png",
        pages: [17]
      },
      {
        filename: "Ch17 Page 18.png",
        pages: [18]
      },
      {
        filename: "Ch17 Page 19.png",
        pages: [19]
      },
      {
        filename: "Ch17 Page 20.png",
        pages: [20]
      },
      {
        filename: "Ch17 Page 21&22.png",
        pages: [21, 22]
      },
      {
        filename: "Ch17 Page 23.png",
        pages: [23]
      },
      {
        filename: "Ch17 Page 24.png",
        pages: [24]
      },
      {
        filename: "Ch17 Page 25.png",
        pages: [25]
      },
      {
        filename: "Ch17 Page 26.png",
        pages: [26]
      }
    ]
  },
  {
    id: "B2",
    label: "B-2",
    folder: "Chapter B2",
    title: "Chapter B-2: ...What Are We?",
    date: "Feb 01 2099",
    publishedAt: "2099-02-01",
    isPublic: false,
    description: "Vivianne Burns is a sweet girl. Which would be a fine thing to be, if she weren't twenty-six. A transplant to Spirit Falls. Vivianne has given herself over to routine. Anne knows exactly what people expect from her. She would like to be someone normal. But she could settle for someone unforgettable. Trapped in a community of fellow monsters yet still an outcast, unsure where she begins and others end, and keeping the secret of her terminally codependent situationship, can Anne ever truly hope to figure herself out?",
    image: "chapterdata/Chapter B2/ChB2 Page 0.png",
    totalPages: 80,
    pageFiles: [
      {
        filename: "ChB2 Page 0.png",
        pages: [0]
      },
      {
        filename: "ChB2 Page 0A.png",
        pages: [1]
      },
      {
        filename: "ChB2 Page 0B.png",
        pages: [2]
      },
      {
        filename: "ChB2 Page 0C.png",
        pages: [3]
      },
      {
        filename: "ChB2 Page 0D.png",
        pages: [4]
      },
      {
        filename: "ChB2 Page 0E.png",
        pages: [5]
      },
      {
        filename: "ChB2 Page 1.png",
        pages: [6]
      },
      {
        filename: "ChB2 Page 2.png",
        pages: [7]
      },
      {
        filename: "ChB2 Page 3.png",
        pages: [8]
      },
      {
        filename: "ChB2 Page 4.png",
        pages: [9]
      },
      {
        filename: "ChB2 Page 5.png",
        pages: [10]
      },
      {
        filename: "ChB2 Page 6.png",
        pages: [11]
      },
      {
        filename: "ChB2 Page 7.png",
        pages: [12]
      },
      {
        filename: "ChB2 Page 8.png",
        pages: [13]
      },
      {
        filename: "ChB2 Page 9.png",
        pages: [14]
      },
      {
        filename: "ChB2 Page 10.png",
        pages: [15]
      },
      {
        filename: "ChB2 Page 11.png",
        pages: [16]
      },
      {
        filename: "ChB2 Page 12.png",
        pages: [17]
      },
      {
        filename: "ChB2 Page 13.png",
        pages: [18]
      },
      {
        filename: "ChB2 Page 14.png",
        pages: [19]
      },
      {
        filename: "ChB2 Page 15.png",
        pages: [20]
      },
      {
        filename: "ChB2 Page 16.png",
        pages: [21]
      },
      {
        filename: "ChB2 Page 17.png",
        pages: [22]
      },
      {
        filename: "ChB2 Page 18&19.png",
        pages: [23, 24]
      },
      {
        filename: "ChB2 Page 20.png",
        pages: [25]
      },
      {
        filename: "ChB2 Page 21.png",
        pages: [26]
      },
      {
        filename: "ChB2 Page 22.png",
        pages: [27]
      },
      {
        filename: "ChB2 Page 23.png",
        pages: [28]
      },
      {
        filename: "ChB2 Page 24&25.png",
        pages: [29, 30]
      },
      {
        filename: "ChB2 Page 26.png",
        pages: [31]
      },
      {
        filename: "ChB2 Page 27.png",
        pages: [32]
      },
      {
        filename: "ChB2 Page 28.png",
        pages: [33]
      },
      {
        filename: "ChB2 Page 29.png",
        pages: [34]
      },
      {
        filename: "ChB2 Page 30.png",
        pages: [35]
      },
      {
        filename: "ChB2 Page 31.png",
        pages: [36]
      },
      {
        filename: "ChB2 Page 32.png",
        pages: [37]
      },
      {
        filename: "ChB2 Page 33.png",
        pages: [38]
      },
      {
        filename: "ChB2 Page 34&35.png",
        pages: [39, 40]
      },
      {
        filename: "ChB2 Page 36.png",
        pages: [41]
      },
      {
        filename: "ChB2 Page 37.png",
        pages: [42]
      },
      {
        filename: "ChB2 Page 38.png",
        pages: [43]
      },
      {
        filename: "ChB2 Page 39.png",
        pages: [44]
      },
      {
        filename: "ChB2 Page 40.png",
        pages: [45]
      },
      {
        filename: "ChB2 Page 41.png",
        pages: [46]
      },
      {
        filename: "ChB2 Page 42.png",
        pages: [47]
      },
      {
        filename: "ChB2 Page 43.png",
        pages: [48]
      },
      {
        filename: "ChB2 Page 44.png",
        pages: [49]
      },
      {
        filename: "ChB2 Page 45.png",
        pages: [50]
      },
      {
        filename: "ChB2 Page 46.png",
        pages: [51]
      },
      {
        filename: "ChB2 Page 47.png",
        pages: [52]
      },
      {
        filename: "ChB2 Page 48.png",
        pages: [53]
      },
      {
        filename: "ChB2 Page 49.png",
        pages: [54]
      },
      {
        filename: "ChB2 Page 50.png",
        pages: [55]
      },
      {
        filename: "ChB2 Page 51.png",
        pages: [56]
      },
      {
        filename: "ChB2 Page 52.png",
        pages: [57]
      },
      {
        filename: "ChB2 Page 53.png",
        pages: [58]
      },
      {
        filename: "ChB2 Page 54.png",
        pages: [59]
      },
      {
        filename: "ChB2 Page 55.png",
        pages: [60]
      },
      {
        filename: "ChB2 Page 56&57.png",
        pages: [61, 62]
      },
      {
        filename: "ChB2 Page 58.png",
        pages: [63]
      },
      {
        filename: "ChB2 Page 59.png",
        pages: [64]
      },
      {
        filename: "ChB2 Page 60.png",
        pages: [65]
      },
      {
        filename: "ChB2 Page 61.png",
        pages: [66]
      },
      {
        filename: "ChB2 Page 62.png",
        pages: [67]
      },
      {
        filename: "ChB2 Page 63.png",
        pages: [68]
      },
      {
        filename: "ChB2 Page 64.png",
        pages: [69]
      },
      {
        filename: "ChB2 Page 65.png",
        pages: [70]
      },
      {
        filename: "ChB2 Page 66.png",
        pages: [71]
      },
      {
        filename: "ChB2 Page 67.png",
        pages: [72]
      },
      {
        filename: "ChB2 Page 68.png",
        pages: [73]
      },
      {
        filename: "ChB2 Page 69.png",
        pages: [74]
      },
      {
        filename: "ChB2 Page 70.png",
        pages: [75]
      },
      {
        filename: "ChB2 Page 71.png",
        pages: [76]
      },
      {
        filename: "ChB2 Page 72.png",
        pages: [77]
      },
      {
        filename: "ChB2 Page 73.png",
        pages: [78]
      },
      {
        filename: "ChB2 Page 74.png",
        pages: [79]
      }
    ]
  }
];

export default chapters;
